import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSidepanelWrapper from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidepanel-wrapper/grossing-touch-sidepanel-wrapper.vue'
import GrossingTouchMediaCard from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-media-card/grossing-touch-media-card.vue'

@Component({
    components: {
        GrossingTouchSidepanelWrapper,
        GrossingTouchMediaCard
    }
})

export default class GrossingTouchAttachmentsSidepanel extends Vue {
    private grossingPictures !: Array<object>

    constructor() {
        super()
        this.grossingPictures = [
            {
                filename: 'Picture_name_1.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            },
            {
                filename: 'Picture_name_2.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            },
            {
                filename: 'Picture_name_3.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            },
            {
                filename: 'Picture_name_4.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            },
            {
                filename: 'Picture_name_5.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            }
        ]
    }
}
